/**
 * @generated SignedSource<<c26f519da753f8c789a03ad97e4ebec6>>
 * @relayHash a1abc713e2d212418f325011eac5ef36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 970cd335229ee31e27c47b2982775f25daa70e4793c40c6bb7810f0d46f11344

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type firstGroupIssues_issueTableGrouping_childIssuesQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns: number;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput: JiraIssueSearchFieldSetsInput;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  isTimelineEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  shouldQueryFieldSetsById: boolean;
  shouldQueryHasChildren: boolean;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
  viewId?: string | null | undefined;
};
export type firstGroupIssues_issueTableGrouping_childIssuesQuery$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraIssueEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"childRowsPagination_issueTableHierarchy_query">;
};
export type firstGroupIssues_issueTableGrouping_childIssuesQuery = {
  response: firstGroupIssues_issueTableGrouping_childIssuesQuery$data;
  variables: firstGroupIssues_issueTableGrouping_childIssuesQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v18 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v19 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v20 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v21 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v22 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v25 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    }
  ]
},
v26 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v20/*: any*/),
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  (v21/*: any*/),
  (v22/*: any*/)
],
v27 = {
  "kind": "ScalarField",
  "name": "id"
},
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v30 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v31 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v32 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v27/*: any*/)
  ]
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v32/*: any*/),
        (v27/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v34 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "name"
},
v36 = {
  "kind": "ScalarField",
  "name": "__id"
},
v37 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v38 = {
  "kind": "ScalarField",
  "name": "type"
},
v39 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v40 = {
  "kind": "ScalarField",
  "name": "value"
},
v41 = [
  (v40/*: any*/),
  (v27/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v42 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v43 = {
  "kind": "ClientExtension",
  "selections": [
    (v42/*: any*/)
  ]
},
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v45 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v46 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v47 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v48 = {
  "kind": "ScalarField",
  "name": "text"
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v35/*: any*/),
    (v43/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v50 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v51 = [
  (v50/*: any*/)
],
v52 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v27/*: any*/)
  ]
},
v53 = [
  (v52/*: any*/)
],
v54 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v55 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v56 = {
  "kind": "ScalarField",
  "name": "picture"
},
v57 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v58 = {
  "kind": "ClientExtension",
  "selections": [
    (v36/*: any*/)
  ]
},
v59 = [
  (v35/*: any*/),
  (v27/*: any*/)
],
v60 = {
  "kind": "ScalarField",
  "name": "date"
},
v61 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v62 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v48/*: any*/),
    (v27/*: any*/)
  ]
},
v63 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v52/*: any*/),
    (v27/*: any*/)
  ]
},
v64 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v65 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v64/*: any*/),
        (v35/*: any*/),
        (v27/*: any*/)
      ]
    },
    (v27/*: any*/)
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v67 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v68 = {
  "kind": "ScalarField",
  "name": "number"
},
v69 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ]
},
v70 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v38/*: any*/),
          (v39/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v30/*: any*/),
                      (v38/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraIssueField"
                      },
                      (v27/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraAffectedServiceConnection",
                            "kind": "LinkedField",
                            "name": "selectedAffectedServicesConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAffectedServiceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                      },
                                      (v35/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraAffectedServicesField"
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraCascadingOption",
                                "kind": "LinkedField",
                                "name": "cascadingOption",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "parentOptionValue",
                                    "plural": false,
                                    "selections": (v41/*: any*/)
                                  },
                                  {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "childOptionValue",
                                    "plural": false,
                                    "selections": (v41/*: any*/)
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraCascadingSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "args": (v44/*: any*/),
                                "concreteType": "JiraComponentConnection",
                                "kind": "LinkedField",
                                "name": "selectedComponentsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v27/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "selectedComponentsConnection(first:1000)"
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraComponentsField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v47/*: any*/),
                              (v35/*: any*/),
                              (v43/*: any*/)
                            ],
                            "type": "JiraDateTimePickerField"
                          },
                          (v49/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraCommentSummary",
                                "kind": "LinkedField",
                                "name": "commentSummary",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canAddComment"
                                  },
                                  (v50/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraCommentSummaryField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "uri"
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraUrlField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": (v51/*: any*/)
                              },
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "fieldOption",
                                "plural": false,
                                "selections": [
                                  (v40/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v53/*: any*/)
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v53/*: any*/)
                                  },
                                  (v27/*: any*/),
                                  (v54/*: any*/)
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraSingleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "selectedOptions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v40/*: any*/),
                                          (v54/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraMultipleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "selectedOptions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v40/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraCheckboxesField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraUserConnection",
                                "kind": "LinkedField",
                                "name": "selectedUsersConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v23/*: any*/),
                                          (v55/*: any*/),
                                          (v35/*: any*/),
                                          (v56/*: any*/),
                                          (v27/*: any*/),
                                          (v57/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "email"
                                              }
                                            ],
                                            "type": "AtlassianAccountUser"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraMultipleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraTeamView",
                                "kind": "LinkedField",
                                "name": "selectedTeam",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "jiraSuppliedId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "jiraSuppliedName"
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraTeamViewField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraTimeTrackingField",
                                    "kind": "LinkedField",
                                    "name": "timeTrackingField",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "timeInSeconds"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "workingHoursPerDay"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "workingDaysPerWeek"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultFormat"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultUnit"
                                          }
                                        ]
                                      },
                                      (v30/*: any*/),
                                      (v35/*: any*/),
                                      (v38/*: any*/),
                                      (v43/*: any*/)
                                    ]
                                  },
                                  (v27/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraOriginalTimeEstimateField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "selectedOption",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "label",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  },
                                  (v27/*: any*/),
                                  (v45/*: any*/)
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraRadioSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "args": (v44/*: any*/),
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "selectedVersionsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v35/*: any*/),
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "selectedVersionsConnection(first:1000)"
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraMultipleVersionPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/)
                                ]
                              },
                              {
                                "args": (v44/*: any*/),
                                "concreteType": "JiraGoalConnection",
                                "kind": "LinkedField",
                                "name": "selectedGoals",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v28/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v58/*: any*/)
                                ],
                                "storageKey": "selectedGoals(first:1000)"
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  (v36/*: any*/),
                                  (v42/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraGoalsField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "args": (v44/*: any*/),
                                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                "kind": "LinkedField",
                                "name": "confluenceRemoteIssueLinks",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "href"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraConfluenceRemoteIssueLinksField"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraCmdbObjectConnection",
                            "kind": "LinkedField",
                            "name": "selectedCmdbObjectsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraCmdbObjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "label"
                                      },
                                      {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbMediaClientConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaClientConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "clientId"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "fileId"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "mediaBaseUrl"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "mediaJwtToken"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "QueryError",
                                "kind": "LinkedField",
                                "name": "errors",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "message"
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraCMDBField"
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": "componentsOld",
                                "concreteType": "JiraComponentConnection",
                                "kind": "LinkedField",
                                "name": "selectedComponentsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v59/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraComponentsField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v48/*: any*/)
                            ],
                            "type": "JiraSingleLineTextField"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v60/*: any*/),
                          (v35/*: any*/),
                          (v61/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "JiraDatePickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/)
                        ],
                        "type": "JiraDateTimePickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraEpic",
                            "kind": "LinkedField",
                            "name": "epic",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "color"
                              },
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraEpicLinkField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "renderedFieldHtml"
                          }
                        ],
                        "type": "JiraFallbackField"
                      },
                      (v49/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v31/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusCategoryField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "statusId"
                              },
                              (v32/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v44/*: any*/),
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "selectedLabelsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraLabelEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v35/*: any*/),
                                      (v52/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": "selectedLabelsConnection(first:1000)"
                          },
                          (v35/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "JiraLabelsField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "small"
                                  }
                                ]
                              },
                              (v35/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraIssueTypeField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "parentIssue",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              (v62/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v62/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v62/*: any*/),
                                  (v27/*: any*/),
                                  (v29/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                          "summary",
                                          "issuetype",
                                          "status"
                                        ]
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v23/*: any*/),
                                              (v27/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  (v48/*: any*/)
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "issueTypeId"
                                                      },
                                                      (v35/*: any*/),
                                                      (v64/*: any*/),
                                                      (v34/*: any*/),
                                                      (v27/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              (v33/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                  }
                                ]
                              },
                              (v35/*: any*/),
                              (v43/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraParentIssueField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          (v35/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "JiraPriorityField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v28/*: any*/),
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "large"
                                  }
                                ]
                              },
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraProjectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraResolution",
                            "kind": "LinkedField",
                            "name": "resolution",
                            "plural": false,
                            "selections": (v59/*: any*/)
                          }
                        ],
                        "type": "JiraResolutionField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraSprintConnection",
                            "kind": "LinkedField",
                            "name": "selectedSprintsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSprintEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                      },
                                      (v35/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "state"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v35/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "JiraSprintField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v35/*: any*/),
                              (v27/*: any*/),
                              (v57/*: any*/)
                            ]
                          },
                          (v35/*: any*/),
                          (v61/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "JiraSingleSelectUserPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          {
                            "args": (v44/*: any*/),
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "selectedVersionsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v59/*: any*/)
                                  }
                                ]
                              }
                            ],
                            "storageKey": "selectedVersionsConnection(first:1000)"
                          }
                        ],
                        "type": "JiraMultipleVersionPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraRichText",
                            "kind": "LinkedField",
                            "name": "richText",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraADF",
                                "kind": "LinkedField",
                                "name": "adfValue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraRichTextField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraServiceManagementRequestType",
                            "kind": "LinkedField",
                            "name": "requestType",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v64/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraServiceManagementRequestTypeField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                              }
                            ],
                            "concreteType": "JiraIssueLinkConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkConnection",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              {
                                "concreteType": "JiraIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                          (v66/*: any*/),
                                          (v28/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "ids",
                                                "value": [
                                                  "statusCategory"
                                                ]
                                              }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v23/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v32/*: any*/)
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                      },
                                                      (v27/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                          },
                                          (v27/*: any*/)
                                        ]
                                      },
                                      (v67/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "issueLinkConnection(first:1)"
                          }
                        ],
                        "type": "JiraIssueLinkField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isStoryPointField"
                          },
                          (v68/*: any*/),
                          (v35/*: any*/),
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              (v68/*: any*/),
                              (v69/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v68/*: any*/),
                              (v35/*: any*/),
                              (v69/*: any*/),
                              (v43/*: any*/)
                            ]
                          },
                          (v43/*: any*/)
                        ],
                        "type": "JiraNumberField"
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "concreteType": "JiraGroupConnection",
                                "kind": "LinkedField",
                                "name": "selectedGroupsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "groupId"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "JiraMultipleGroupPickerField"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraFlag",
                                "kind": "LinkedField",
                                "name": "flag",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFlagged"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraFlagField"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraWatch",
                                "kind": "LinkedField",
                                "name": "watch",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "count"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isWatching"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraWatchesField"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v51/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  }
],
v71 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v72 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v39/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v60/*: any*/)
                        ],
                        "type": "JiraDatePickerField"
                      },
                      (v27/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "kind": "Fragment",
    "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
          },
          {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
          }
        ],
        "kind": "FragmentSpread",
        "name": "childRowsPagination_issueTableHierarchy_query"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "issueSearch",
            "args": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/)
                    ]
                  }
                ]
              },
              (v25/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v17/*: any*/),
      (v13/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v14/*: any*/),
      (v5/*: any*/),
      (v16/*: any*/),
      (v15/*: any*/),
      (v9/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v26/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isResolved"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                              "status"
                            ]
                          }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v33/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldsById(ids:[\"status\"])"
                      },
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          (v27/*: any*/)
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "condition": "shouldQueryFieldSetsById",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                  },
                                  (v37/*: any*/)
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsById",
                                "plural": false,
                                "selections": (v70/*: any*/)
                              }
                            ]
                          },
                          {
                            "condition": "shouldQueryFieldSetsById",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "fieldSetsContext"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                  },
                                  (v37/*: any*/),
                                  {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                  }
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsForIssueSearchView",
                                "plural": false,
                                "selections": (v70/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v71/*: any*/),
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": (v70/*: any*/),
                    "storageKey": "fieldSets(first:500)"
                  },
                  {
                    "condition": "shouldQueryHasChildren",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasChildren"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canHaveChildIssues"
                      }
                    ]
                  },
                  (v58/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
              },
              {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
              },
              (v25/*: any*/),
              {
                "condition": "isTimelineEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "args": (v71/*: any*/),
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": (v72/*: any*/),
                        "storageKey": "fieldSets(first:500)"
                      },
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                              }
                            ],
                            "concreteType": "JiraIssueLinkConnection",
                            "kind": "LinkedField",
                            "name": "issueLinks",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "fieldSetIds",
                                                "value": [
                                                  "Start date[Date]"
                                                ]
                                              }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": (v72/*: any*/),
                                            "storageKey": "fieldSetsById(fieldSetIds:[\"Start date[Date]\"])"
                                          },
                                          (v29/*: any*/),
                                          (v27/*: any*/)
                                        ]
                                      },
                                      (v67/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "issueLinks(first:10)"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v58/*: any*/)
            ]
          },
          {
            "args": (v26/*: any*/),
            "filters": [
              "cloudId",
              "issueSearchInput",
              "options",
              "fieldSetsInput",
              "viewConfigInput"
            ],
            "handle": "connection",
            "key": "hierarchy_nativeIssueTable__issueSearch",
            "kind": "LinkedHandle",
            "name": "issueSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "970cd335229ee31e27c47b2982775f25daa70e4793c40c6bb7810f0d46f11344",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "bidirectional",
          "path": [
            "jira",
            "issueSearch"
          ]
        }
      ]
    },
    "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "3eb85b224f1d181caeb0050dacb249d7";

export default node;
